import script from "./FrSegmented.vue?vue&type=script&setup=true&lang=ts"
export * from "./FrSegmented.vue?vue&type=script&setup=true&lang=ts"

import "./FrSegmented.vue?vue&type=style&index=0&id=68aafafa&lang=scss"

const __exports__ = script;

export default __exports__